import React from 'react';
import { shiftLocalDay } from '../../utils/dateFormatting';

// Sticky London-day picker with previous/next buttons. `date` is "YYYY-MM-DD".
const DateBar = ({ date, onChange }) => (
    <div className="sticky top-0 z-20 -mx-4 sm:-mx-6 lg:-mx-8 px-4 sm:px-6 lg:px-8 py-3 mb-6 bg-white/85 backdrop-blur border-b border-gray-100">
        <div className="flex justify-center">
            <div className="flex items-center gap-0 shadow-sm">
                <button
                    onClick={() => onChange(shiftLocalDay(date, -1))}
                    aria-label="Previous day"
                    className="px-3 py-2 border border-gray-200 rounded-l-lg text-gray-500 hover:bg-gray-50 text-sm"
                >
                    &lsaquo;
                </button>
                <input
                    type="date"
                    aria-label="Day"
                    value={date}
                    onChange={(e) => e.target.value && onChange(e.target.value)}
                    className="px-3 py-2 bg-white border-t border-b border-gray-200 text-sm text-gray-700 focus:outline-none"
                />
                <button
                    onClick={() => onChange(shiftLocalDay(date, 1))}
                    aria-label="Next day"
                    className="px-3 py-2 border border-gray-200 rounded-r-lg text-gray-500 hover:bg-gray-50 text-sm"
                >
                    &rsaquo;
                </button>
            </div>
        </div>
    </div>
);

export default DateBar;
